<template>
  <div class="ibox" ref="portalConfiguration">
    <div class="ibox-title">
      <h4>Portal configuration</h4>
      <div class="ibox-tools">
        <a class="collapse-link">
            <i class="fa fa-chevron-down"></i>
        </a>
      </div>
    </div>
    <div class="ibox-content" style="display:none">
    

      <form id="config-portal-form" name="config-portal-form" role="form" action="#" method="post" @submit="onFormSubmit">

        <div class="form-group">
            <label for="addressAutoComplete">{{ $t('configuration.portal.addressAutoComplete') }}</label>
            <div>
              <p-check id="addressAutoComplete" class="p-switch p-fill" color="success" v-model="form.addressAutoComplete">&nbsp;</p-check>
            </div>
        </div>
        <div class="form-group">
            <label for="vatValidation">{{ $t('configuration.portal.vatValidation') }}</label>
            <div>
              <p-check id="vatValidation" class="p-switch p-fill" color="success" v-model="form.vatValidation">&nbsp;</p-check>
            </div>
        </div>

        <button type="submit" class="btn btn-primary block full-width ladda-button" data-style="zoom-in">{{ $t('configuration.form.button') }}</button>

      </form>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from '@fwk-node-modules/vue';
import { Component, Prop, Watch } from '@fwk-node-modules/vue-property-decorator';
import * as api from '@fwk-client/utils/api';
import * as Ladda from 'ladda';
import { enableIbox, disableIbox} from '../../../theme/inspinia-jquery'; 

@Component({
  components: { },
  
})
export default class Portal extends Vue {

  @Prop({
    type: Object,
    required: true
  }) readonly config!: any

  form = {
    addressAutoComplete : this.config.addressAutoComplete,
    vatValidation : this.config.vatValidation
  }

  laddaSubmit:Ladda.LaddaButton|null = null;

  mounted() {
    var button:HTMLButtonElement|null = document.querySelector( 'form[name=config-portal-form] button.ladda-button' );
    this.laddaSubmit = Ladda.create(button!);

    enableIbox(this.$refs.portalConfiguration as HTMLElement);
  }

  beforeDestroy() {
    disableIbox(this.$refs.portalConfiguration as HTMLElement);
  }

  onFormSubmit(evt:Event) {
    evt.preventDefault();

    var options:api.ApiVueOptions =  {
      app: this
    }

    this.laddaSubmit!.start();
    
    api.postAPI('/api/config/portal/update', this.form, options).then((response:any) => {
      
      this.laddaSubmit!.stop();
    });
  }
  
}
</script>